// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__33jVs","label":"Radio_label__4j1-j","checkMark":"Radio_checkMark__2GOgj","disabled":"Radio_disabled__3eOW_"};